import ToggleItem from './toggle_item';

export default class Bold extends ToggleItem {
  constructor() {
    super('font-bold', 'Ctrl+B');
  }
}
